import script from "./goalsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./goalsSection.vue?vue&type=script&setup=true&lang=js"

import "./goalsSection.vue?vue&type=style&index=0&id=362cca99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362cca99"]])

export default __exports__